import styled from '@emotion/styled';

import { ICustomTheme } from 'interfaces';

const Heading = styled.div(({ theme }: { theme: ICustomTheme }) => ({
  padding: theme.spacing(1, 3),
  backgroundColor: theme.colors.grey.light5,
  color: theme.colors.grey.light,
}));

export default Heading;
